import Layout from "../../components/reusable/Layout";

import classes from "./TrainerNotePage.module.css";
import CustomCard from "../../components/reusable/CustomCard";

interface Props {
  data: any;
}
const TrainerNotePage = ({ data }: Props) => {
  return (
    <Layout isDarkTheme={true} customPadding={40}>
      <CustomCard
        isDarkTheme={true}
        cardHeight="100%"
        cardWidth="100%"
        cardPadding="40px"
      >
        {data
          .replaceAll("<br>", "\n")
          .split(/[\r\n]+/)
          .map((el: string) => (
            <p className={classes.text} key={el}>
              {el}
            </p>
          ))}
      </CustomCard>
    </Layout>
  );
};

export default TrainerNotePage;
